    import React, { useState, useEffect } from 'react'
    import './AdminDashboard.css';
    import { useNavigate } from 'react-router-dom';

    const AdminDashboard = () => {

        const [logout, setLogout] = useState(false);
        const navigate = useNavigate();
        const [showAddBlog, setShowAddBlog] = useState(false);
        const [formData, setFormData] = useState({
            title: '',
            category: '',
            description: '',
            image: null
        })
        const categories = ['Mutual Funds', 'Personal Finance', 'PMS & AIFs', 'Sector Outlook'];
        const [responseMsg, setResponseMsg] = useState('');
        const [loading, setLoading] = useState(false);
        const [blogs, setBlogs] = useState([]);
    const [showDel, setShowDel] = useState(false);
    const [selectedBlog, setSelectedBlog] = useState('');
const [isEditMode, setIsEditMode] = useState(false);
const [selectedCategory, setSelectedCategory] = useState('All');


    const handleLogout = () => {
        localStorage.removeItem('isLoggedIn', 'true');
        navigate('/admin-login');
        window.location.reload();
    }


 const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      image: e.target.files[0],
    }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  const data = new FormData();
  data.append('title', formData.title);
  data.append('category', formData.category);
  data.append('description', formData.description);
  if (formData.image) {
    data.append('image', formData.image);
  }

  setLoading(true);

  try {
    const url = isEditMode
      ? `https://api.shaktitours.com/update-blog/${selectedBlog.id}`
      : 'https://api.shaktitours.com/post-blog';

    const method = isEditMode ? 'PUT' : 'POST';

    const response = await fetch(url, {
      method,
      body: data,
    });

    if (response.ok) {
      setResponseMsg(isEditMode ? 'Blog updated successfully!' : 'Blog posted successfully!');
      setShowAddBlog(false);
      setIsEditMode(false);
      setFormData({
        title: '',
        category: '',
        description: '',
        image: null,
      });
      fetchBlogs();
    } else {
      setResponseMsg('Something Went Wrong. Try again.');
    }

    setLoading(false);
    setTimeout(() => setResponseMsg(''), 2000);
  } catch (error) {
    console.error('Error:', error);
    setLoading(false);
  }
};


              useEffect(() => {
                fetchBlogs();
            }, []);


                            const fetchBlogs = async () => {
                    setLoading(true);
                    try {
                        const response = await fetch('https://api.shaktitours.com/get-blog');
        
                        if (response.ok) {
                            const data = await response.json();
                            console.log(data);
  data.sort((a, b) => new Date(b.added_on) - new Date(a.added_on));
  setBlogs(data);
                            setLoading(false);
                        } else {
                            setLoading(false);
                            console.error('Failed to fetch coupon');
                        }
                    } catch (error) {
                        setLoading(false);
                        console.error('Error fetching data:', error);
                    }
                };

                
const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
};


      const handleShowDel = (blog) => {
    setSelectedBlog(blog);
    setShowDel(true);
  }


                const handleDelete = async (blogId) => {
    try {
      const response = await fetch(`https://api.shaktitours.com/delete-blog/${blogId}`, {
        method: 'DELETE',
      });


      if (response.ok) {
setBlogs((prevProducts) => prevProducts.filter((blog) => blog.id !== blogId));
        setShowDel(false);
        setResponseMsg('Blog deleted successfully!');
        setTimeout(() => {
          setResponseMsg('');
        }, 2000);
      } else {
        setShowDel(false);
      setResponseMsg('Something Went Wrong. Please try again.');
        setTimeout(() => {
          setResponseMsg('');
        }, 2000);  
      }
    } catch (error) {
      console.error('Error deleting blog:', error);
    }
  };


  const handleShowEdit = (blog) => {
  setFormData({
    title: blog.title,
    category: blog.category,
    description: blog.description,
    image: null,
  });
  setSelectedBlog(blog);
  setIsEditMode(true);
  setShowAddBlog(true);
};


const filteredBlogs = selectedCategory === 'All'
  ? blogs
  : blogs.filter(blog => blog.category === selectedCategory);



    return (
        <>
        <div className='sidebar-left'>
            <span className='sidebar-icon' onClick={() => navigate('/dashboard')}><i class="fa-solid fa-house"></i></span><br /><br/>
            <span className='sidebar-icon' onClick={() => navigate('/enquiry')}><i class="fa-solid fa-circle-question"></i></span><br /><br/>
            <span className='sidebar-icon' onClick={() => setLogout(true)}><i class="fa-solid fa-power-off"></i></span>
        </div>

        <div className='sidebar-right'>
        <div className='sidebar-right-inner'>

            <div className='d-flex justify-content-between'>
            <p className='fw-bold fst-italic fs-5 text-nowrap my-3 me-2'>Hello Admin!</p>
    <button className='btn btn-warning fw-semibold my-2' onClick={() => setShowAddBlog(true)}>Post A Blog</button></div>


<div className='row text-light fw-semibold'>

<div className='col-md-3 col-6 my-2' onClick={() => setSelectedCategory('Mutual Funds')} style={{ cursor: 'pointer' }}>
  <div className='bg-success py-4 px-4 rounded-4'>
    <p>Mutual Funds</p>
    {blogs.filter(blog => blog.category === 'Mutual Funds').length}
  </div>
</div>

<div className='col-md-3 col-6 my-2' onClick={() => setSelectedCategory('Personal Finance')} style={{ cursor: 'pointer' }}>
<div className='bg-warning py-4 px-4 rounded-4'>
    <p>Personal Finance</p>
{blogs.filter(blog => blog.category === 'Personal Finance').length}
</div>
</div>

<div className='col-md-3 col-6 my-2' onClick={() => setSelectedCategory('PMS & AIFs')} style={{ cursor: 'pointer' }}>
<div className='bg-primary py-4 px-4 rounded-4'>
    <p>PMS and AIFs</p>
{blogs.filter(blog => blog.category === 'PMS & AIFs').length}
</div> 
</div>

<div className='col-md-3 col-6 my-2' onClick={() => setSelectedCategory('Sector Outlook')} style={{ cursor: 'pointer' }}>
<div className='bg-danger py-4 px-4 rounded-4'>
    <p>Sector Outlook</p>
{blogs.filter(blog => blog.category === 'Sector Outlook').length}
</div> 
</div>


</div>
{/* row ends */}

{responseMsg && <p className='my-0 fw-semibold text-muted text-decoration-underline fst-italic'>{responseMsg}</p>}


                {filteredBlogs.map(blog => (
                  <div className='blog-card my-3 w-100'>
  <div className='row '>
    <div className='col-lg-4 col-md-4 my-2'>
      <img src={`https://api.shaktitours.com/pUploads/${blog.image}`} className='img-fluid' />
      </div>

  <div className='col-lg-8 col-md-8 col-12 my-2'>
  <p className='fw-bold fm-mont my-0'>{blog.title}</p>
    <p className='text-muted para-text'>Posted On: {formatDate(blog.added_on)}<br /></p>
    <span className='bg-secondary rounded text-light px-2 py-1 fw-semibold para-text'>{blog.category}</span>
  <p className='text-muted mt-3'>{blog.description}</p>

<button className='submit-btn py-2 mb-2 me-2' onClick={() => handleShowEdit(blog)}>Edit / Update</button>
  <button className='submit-btn py-2 mb-2' onClick={() => handleShowDel(blog)} >Delete</button>
    </div>

  </div>
  </div>
                ))}



    </div>      </div>


    {logout && (
        <div className='dialog-outer px-2'>
            <div className='dialog-inner col-lg-5 mx-auto py-5'>

    <p className='fs-5 fw-bold mb-4'>Logout Admin Account!</p>

    <button className='submit-btn px-3 py-2' onClick={() => handleLogout()}>Yes</button>&nbsp;&nbsp;
    <button className='submit-btn px-3 py-2' onClick={() => setLogout(false)}>No</button>


            </div>
        </div>
    )}


    {showAddBlog && (
            <div className='dialog-outer px-2'>
            <div className='dialog-inner col-lg-5 mx-auto py-4 text-start'>
<p className='fs-5 fw-bold'>{isEditMode ? 'Edit Blog' : 'Post New Blog'}</p>
    <hr className='bg-secondary opacity-75 border-0 pb-1 w-25' />


 <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Title</label>
                <input
                  type="text"
                  name="title"
                  className="w-100 rounded py-2 px-3 border-dark-subtle"
                  value={formData.title}
                  onChange={handleInputChange}
                  required
                />
              </div>

<div className="mb-3">
  <label className="form-label">Category</label>
  <select
    name="category"
    className="w-100 rounded py-2 px-3 border-dark-subtle"
    value={formData.category}
    onChange={handleInputChange}
    required
  >
    <option value="">-- Select Category --</option>
    {categories.map((cat, index) => (
      <option key={index} value={cat}>
        {cat}
      </option>
    ))}
  </select>
</div>

              <div className="mb-3">
                <label className="form-label">Description</label>
                <textarea
                  name="description"
                  className="w-100 rounded py-2 px-3 border-dark-subtle"
                  rows="4"
                  value={formData.description}
                  onChange={handleInputChange}
                  required
                ></textarea>
              </div>

{!isEditMode && (
  <div className="mb-3">
    <label className="form-label">Image</label>
    <input
      type="file"
      name="image"
      className="w-100 rounded py-2 px-3 border-dark-subtle border"
      onChange={handleFileChange}
      accept="image/*"
      required
    />
  </div>
)}


              <div className="d-flex justify-content-end">
                <button type="button" className="btn btn-secondary me-2" onClick={() => setShowAddBlog(false)}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-warning">
                  {loading ?  <i class="fa-solid fa-circle-notch fa-spin text-light px-3 fs-5"></i>: 'Submit'}
                </button>
              </div>
            </form>


                </div>
            </div>
    )}


                  {showDel && (
    <>
    <section className='dialog-outer'>
        <div className='dialog-inner col-lg-4 mx-auto text-center py-5'>
            
            <p className='fw-semibold'>Want to Delete '{selectedBlog.title}'?</p>

                  <button type='submit' className='btn btn-warning me-2' onClick={() => handleDelete(selectedBlog.id)}>
                    Yes
                  </button>
                  <button type='button' className='btn btn-secondary' onClick={() => setShowDel(false)}>
                    No
                  </button>
        </div>
    </section>
    </>
)}
        </>
    )
    }

    export default AdminDashboard
